<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Авансирование/Удержание</h3>

      <div class="filters">
        <div v-if="isAdmin() || isManagerFC()">
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheYear" class="form-label col-md-3">
                Год
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheYear" id="trancheYear"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(year, index) in trancheYears" :key="index" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheNumber" class="form-label col-md-3">
                Номер транша
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheNumber" id="trancheNumber"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(trancheNumber, index) in trancheNumbers" :key="index" :value="trancheNumber">
                    {{ trancheNumber }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="university" class="form-label col-md-3">
                ВУЗ
              </label>
              <div class="col-md-9">
                <multiselect
                    v-model="page.filter.university"
                    :options="universities"
                    :searchable="true"
                    :closeOnSelect="true"
                    label="nameRu"
                    track-by="universityId"
                    :close-on-select="true"
                    :allow-empty="true"
                    placeholder="Выберите ВУЗ"
                    :multiple="false"
                    :clear-on-select="true"
                    @select="val => {
                      page.filter.universityId = val?.universityId || null;
                      reloadList();
                    }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end">

      <b-button variant="primary"
                @click="reloadList()">
        Найти
      </b-button>

      <b-button variant="success" @click="onShowEditDialog(null)" class="mx-lg-1">
        Добавить
      </b-button>

<!--      <b-button variant="success"-->
<!--                v-if="isManagerFC() || isUniversityManager()"-->
<!--                :disabled="items.length === 0"-->
<!--                @click="onClickExportStudents()">-->
<!--        Экспортировать в MS Excel-->
<!--      </b-button>-->

      <b-button variant="danger"
                :disabled="selectedItemIds.length === 0"
                v-if="isAdmin()"
                @click="onClickSelectedRemove()">
        Удалить выбранные
      </b-button>

<!--      <b-button variant="danger"-->
<!--                style="margin-left: 5px"-->
<!--                :disabled="items.length === 0"-->
<!--                v-if="isAdmin()"-->
<!--                @click="onClickAllRemove()">-->
<!--        Удалить все-->
<!--      </b-button>-->
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(bin)="data">
        <div class="sortable-container none"
             @click="onSortChanged('bin')"
             :class="{'ascending': page.sort.bin === 'ASC', 'descending': page.sort.bin === 'DESC'}">
          БИН
        </div>
      </template>
      <template #head(universityName)="data">
        <div class="sortable-container none"
             @click="onSortChanged('universityName')"
             :class="{'ascending': page.sort.universityName === 'ASC', 'descending': page.sort.universityName === 'DESC'}">
          ВУЗ
        </div>
      </template>
      <template #head(totalSum)="data">
        <div class="sortable-container none"
             @click="onSortChanged('totalSum')"
             :class="{'ascending': page.sort.totalSum === 'ASC', 'descending': page.sort.totalSum === 'DESC'}">
          Сумма
        </div>
      </template>
      <template #head(comment)="data">Комментарий</template>
      <template #head(actions)="data" v-if="canRemove()"></template>

      <template #cell(index)="data">
        <div class="form-check2">
          <input class="form-check-input" type="checkbox"
                 v-on:change="onCheckItem(data.item)"
                 v-model="data.item.selected"/>
        </div>

      </template>

      <template #cell(bin)="data">
        {{ data.item.university?.bin }}
      </template>
      <template #cell(universityName)="data">
        <a @click="onShowEditDialog(data.item)">
          {{ data.item.university?.nameRu }}
        </a>
      </template>

      <template #cell(totalSum)="data">
        <span :class="data.item.totalSum > 0 ? 'color-green' : 'color-red'">{{ data.item.totalSum }} </span>
      </template>
      <template #cell(comment)="data"> {{ data.item.comment }} </template>
      <template #cell(actions)="data" v-if="canRemove()">
        <div class="action-cell">
          <b-button class="btn btn-danger btn-sm delete-button"
                    @click="onClickRemove(data.item)">
            Удалить
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <!-- Modal component -->
  <b-modal v-model="showModal" title="Добавление авансирование/удержание" @ok="submitForm">
    <form @submit.prevent="submitForm" class="mb-4">
      <div class="mb-3">
        <label for="trancheYear" class="form-label">
          Год
        </label>
        <select v-model="dialog.itemDto.trancheYear" id="trancheYear" required
                class="form-select">
          <option v-for="(year, index) in trancheYears" :key="index" :value="year">
            {{ year }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="trancheNumber" class="form-label">
          Номер транша
        </label>
        <select v-model="dialog.itemDto.trancheNumber" id="trancheNumber"
                class="form-select" required>
          <option v-for="(trancheNumber, index) in trancheNumbers" :key="index" :value="trancheNumber">
            {{ trancheNumber }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="university" class="form-label">
          ВУЗ {{dialog.itemDto.id}}
        </label>
        <multiselect
            v-model="dialog.itemDto.university"
            :options="universities"
            :searchable="true"
            :closeOnSelect="true"
            label="nameRu"
            :disabled="dialog.itemDto.uuid != null"
            track-by="universityId"
            :close-on-select="true"
            :allow-empty="false"
            placeholder="Выберите ВУЗ"
            :multiple="false"
        />
      </div>


      <div class="mb-3">
        <label for="totalSum" class="form-label">
          Сумма авансирование/удержание
        </label>
        <input class="form-control" type="number" required
               id="totalSum" v-model="dialog.itemDto.totalSum">
      </div>

      <div class="mb-3">
        <label for="comment" class="form-label">
          Комментарий
        </label>
        <textarea v-model="dialog.itemDto.comment"
                  id="comment"
                  class="form-control"
                  rows="5"></textarea>
      </div>

    </form>
  </b-modal>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import militaryStudentService from "@/services/militaryStudentService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import universityService from "@/services/universityService";
import settingsService from "@/services/settingsService";
import delegationService from "@/services/delegationService";

import Multiselect from "vue-multiselect";
import advanceDeductionService from "@/services/advanceDeductionService";

export default {
  components: {
    VueLoading,
    Multiselect
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      setting: {
        defaultTrancheYear: null,
        defaultTrancheNumber: null
      },
      page: {
        filter: {
          trancheYear: null,
          trancheNumber: null,
          universityId: null
        },
        sort: {
          bin: null,
          universityName: null,
          totalSum: null
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'index', label: '#', sortable: false, thStyle: { width: "40px" }},
        {key: 'bin', label: 'БИН', sortable: true},
        {key: 'universityName', label: 'ВУЗ', sortable: true},
        {key: 'totalSum', label: 'Авансирование/удержание', sortable: true},
        {key: 'comment', label: 'Комментарий', sortable: false},
        {key: 'actions', sortable: false}
      ],
      items: [],
      selectedItemIds: [],
      universities: [],
      yesNoList: [
        {id: true, nameRu: "Да"},
        {id: false, nameRu: "Нет"},
      ],
      dialog: {
        itemDto: {
          trancheYear: null,
          trancheNumber: null,
          university: null,
          totalSum: null,
          comment: null
        }
      },
      trancheYears: Array.from({length: 7}, (v, i) => 2024 + i),
      trancheNumbers: Array.from({length: 4}, (v, i) => 1 + i)
    };
  },
  methods: {
    init() {
      this.initSettings().then(response => {
        this.page.filter.trancheYear = this.setting.defaultTrancheYear;
        this.page.filter.trancheNumber = this.setting.defaultTrancheNumber;

        this.reloadList();
      });
    },
    async reloadList() {
      this.selectedItemIds = [];
      this.isLoading = true;
      const response = await advanceDeductionService.getAll(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },
    async submitForm() {

      this.isLoading = true;

      try {

        await advanceDeductionService.save(this.dialog.itemDto);

        this.reloadList();

        showSuccessNotify("Данные успешно  сохранены");
        this.showModal = false;
      } catch (error) {
        showErrorNotify("Возникла ошибка при сохранение данных");
      } finally {
        this.isLoading = false;
      }
    },
    async onClickRemove(item) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот элемент?");
      if (confirmed) {
        try {
          await advanceDeductionService.deleteById(item.uuid);

          this.reloadList();

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },

    async initSettings() {
      this.setting = await settingsService.load();
    },
    initUniversities() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      universityService.getAll(params)
          .then(response => {
            this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },

    canRemove() {
      return this.isAdmin();
    },

    onShowEditDialog(item) {
      this.showModal = true;
      if (!item) {
        item = {trancheYear: this.setting.defaultTrancheYear, trancheNumber: this.setting.defaultTrancheNumber}
      }
      this.dialog.itemDto = Object.assign({}, item);
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isManagerFC() {
      return delegationService.isManagerFC();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
    onCheckItem(item) {
      if (item.selected) {
        this.selectedItemIds.push(item.uuid);
      } else {
        const index = this.selectedItemIds.findIndex(uuid => uuid === item.uuid);
        if (index !== -1) {
          this.selectedItemIds.splice(index, 1);
        }
      }
    },
    async onClickSelectedRemove() {
      console.log('onClickSelectedRemove', this.selectedItemIds);

      const confirmed = await confirm("Вы уверены, что хотите удалить выбранные элементы?");
      if (confirmed) {
        try {
          await advanceDeductionService.deleteByIds(this.selectedItemIds);

          this.reloadList();

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },

    async onClickAllRemove() {

      const confirmed = await confirm("Вы уверены, что хотите удалить все элементы?");
      if (confirmed) {
        try {
          this.isLoading = true;
          await militaryStudentService.deleteAllByYear(this.page.filter.trancheYear, this.page.filter.trancheNumber, this.page.filter.universityId);
          this.isLoading = false;

          this.reloadList();

          showSuccessNotify('Все успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    }
  },
  mounted() {
    this.initUniversities();

    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.ascending {
  background-image: url("../assets/asc.svg") !important;
}

.descending {
  background-image: url("../assets/desc.svg") !important;
}

.none {
  background-image: url("../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

.delete-button {
  display: flex;
  align-items: center;
}
.color-green {
  color: darkgreen;
}
.color-red {
  color: darkred;
}
</style>
